<template>
  <div :class="[
      element.playing ? 'animated ' + element.animatedName : '',
      element.loop ? 'infiniteKKKKK' : '',
      'element-wrapper',
      element._groupId ? element._groupId : ''
    ]"
    :style="{
      transform: 'rotate(' + element.transform + 'deg)',
      'z-index': element.zindex,
      opacity: element.opacity / 100,
      width: element.width + 'px',
      height: element.height + 'px',
      top: element.top + 'px',
      left: element.left + 'px',
      'animation-duration': element.duration + 's',
      '-webkit-animation-duration': element.duration + 's',
      'animation-delay': element.delay + 's',
      '-webkit-animation-delay': element.delay + 's',
      'display': (element.isHidden == null || !element.isHidden) ? 'block' : 'none'
    }">
    <div v-if="element.type !== 'scene'">
      <component :is="getCompName(element.type)" :element="element"></component>
    </div>
  </div>
</template>

<script>
import EditorTable from '@/editorComponents/Table/index'
import Navigation from '@/editorComponents/Navigation/index'
import EditorPicture from '@/editorComponents/Picture/index'
import EditorText from '@/editorComponents/Text/index'
import EditorOnOff from '@/editorComponents/OnOff/index'
import EditorChart from '@/editorComponents/Chart/index'
import EditorRadio from '@/editorComponents/Radio/index'
import EditorSelect from '@/editorComponents/Select/index'
import EditorButton from '@/editorComponents/Button/index'
import EditorCheckBox from '@/editorComponents/CheckBox/index'
import EditorSwiper from '@/editorComponents/Swiper/index'
import EditorVideos from '@/editorComponents/Videos/index'

export default {
  name: 'DummyElement',
  props: {
    element: {
      type: Object,
      require: true,
      default: null
    }
  },
  data: () => {
    return {}
  },
  mounted() {},
  methods: {
    // 根据元素类型获取组件名称
    getCompName(type) {
      let componentName = ''
      switch (type) {
        case 'pic':
          componentName = 'EditorPicture'
          break
        case 'text':
          componentName = 'EditorText'
          break
        case 'table':
          componentName = 'EditorTable'
          break
        case 'navigation':
          componentName = 'Navigation'
          break
        case 'chart':
          componentName = 'EditorChart'
          break
        case 'onOff':
          componentName = 'EditorOnOff'
          break
        case 'radio':
          componentName = 'EditorRadio'
          break
        case 'checkBox':
          componentName = 'EditorCheckBox'
          break
        case 'select':
          componentName = 'EditorSelect'
          break
        case 'button':
          componentName = 'EditorButton'
          break
        case 'swiper':
          componentName = 'EditorSwiper'
          break
        case 'videos':
          componentName = 'EditorVideos'
          break
        default:
          componentName = null
          break
      }
      return componentName
    }
  },
  components: {
    EditorTable,
    EditorPicture,
    EditorText,
    EditorChart,
    Navigation,
    EditorOnOff,
    EditorRadio,
    EditorSelect,
    EditorButton,
    EditorCheckBox,
    EditorSwiper,
    EditorVideos
  }
}
</script>

<style lang='less' scoped>
.element-wrapper {
  position: absolute;
}
</style>
